import { useNavigate } from 'react-router-dom';

import Targets from "./targets";

import { appendSearchParams } from "react-router-easy";

var useENavigate = function useENavigate() {
    var navigate = useNavigate();

    var to = function to(url, options) {
        if (url === undefined) {
            url = '';
        }
        if (options) {
            var target = options.target,
                auto = options.auto,
                size = options.size;
            if (target) {
                target = target.toLowerCase();
                if (target === Targets._blank) {
                    target = undefined;
                }
            }
            if (size) {
                size = size.toLowerCase();
            }
            if (target || auto) {
                var searchParams = {};
                if (target) {
                    searchParams.__target__ = target;
                }
                if (auto) {
                    searchParams.__auto__ = auto;
                }
                if (size) {
                    searchParams.__size__ = size;
                }
                url = appendSearchParams(url, searchParams);
            }
        }

        navigate(url);
    };

    var right = function right(url, options) {
        if (!options) {
            options = {};
        }
        options.target = Targets._right;
        to(url, options);
    };

    var dialog = function dialog(url, options) {
        if (!options) {
            options = {};
        }
        options.target = Targets._dialog;
        to(url, options);
    };

    return {
        to: to,
        right: right,
        dialog: dialog
    };
};

export default useENavigate;